import {combineReducers} from 'redux';

import productsReducers from './productReducers.js';
import placesReducers from './placesReducers.js';
import mRecoveryReducer from './chart-reducers/mRecoveryReducers.js';
import lossUtilityReducer from './chart-reducers/lossUtilityReducers.js';
import amountPortfolioReducer from './chart-reducers/amountPortfolio.js';
import headerActiveStyleReducer from './style-switcher-reducers/headeractiveReducer.js';
import sidebarActiveStyleReducer from './style-switcher-reducers/sidebarActiveReducer.js';
import headerBannerActiveStyleReducer from './style-switcher-reducers/headerBannerActiveReducer.js';
import globalPortfolioReduceReducer from './chart-reducers/globalPortfolioReduce'

const allReducers = combineReducers({
  products: productsReducers,
  places: placesReducers,
  monthlyRecovery: mRecoveryReducer,
  lossUtility: lossUtilityReducer,
  amountPortfolio: amountPortfolioReducer,
  headerActiveStyle: headerActiveStyleReducer,
  sidebarActiveStyle: sidebarActiveStyleReducer,
  headerBAnnerActiveStyle: headerBannerActiveStyleReducer,
  globalPorfolioReduce: globalPortfolioReduceReducer,
});

export default allReducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js